// Author YuJiaBei
// Date 2020-11-12 10:33:16

class InspectionResult {
constructor({
        id = null,
        name = '',
        generateAbnormalWorkflow = '',
        description = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.generateAbnormalWorkflow = generateAbnormalWorkflow;
    this.description = description;
}
}

function newEntity() {
return new InspectionResult();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.em.inspection.inspectionResult.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'generateAbnormalWorkflow',
        label: 'label.em.inspection.inspectionResult.grid.generateAbnormalWorkflow',
        sortable: true,
        form: {
        type: 'boolean'
        }
        },
        {
        key: 'description',
        label: 'label.em.inspection.inspectionResult.grid.description',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    nameFilter : "",
    generateAbnormalWorkflowFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.inspection.inspectionResult.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'generateAbnormalWorkflowFilter',
        label: 'label.em.inspection.inspectionResult.filter.generateAbnormalWorkflow',
        disabled: false,
        form: {
        type: 'boolean'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.inspection.inspectionResult.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'generateAbnormalWorkflow',
        label: 'label.em.inspection.inspectionResult.entity.generateAbnormalWorkflow',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'description',
        label: 'label.em.inspection.inspectionResult.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {InspectionResult, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
